<div class='Login container'>
  <div class='Login_wrapper d-flex flex-column'>
    <div class='Login_wrapper_header'>
      <h1 class=''>Login</h1>
      <h5 class='mt-3'>
        Ready to set more meetings today? The President’s Club is calling.
      </h5>
      <div class='AuthenticatedLayout-container-alerts container pt-3'>
        <div
          *ngIf='showAlert && alertMessage'
          class='alert alert-danger alert-dismissible fade show'
          role='alert'>
          {{ alertMessage }}
          <button
            (click)='closeAlert()'
            aria-label='Close'
            class='btn-close'
            data-bs-dismiss='alert'
            type='button'></button>
        </div>
      </div>
    </div>
    <div class='Login_wrapper_body p-5'>
      <form
        (keydown)='onKeyDown($event)'
        [formGroup]='loginForm'
        accept-charset='UTF-8'
        action='/accounts/sign_in'
        class='form-sign-in sign_in_form pt-3'
        id='new_account'
        method='post'>
        <div style='margin: 0; padding: 0; display: inline'>
          <input name='utf8' type='hidden' value='✓' /><input
          name='authenticity_token'
          type='hidden'
          value='ODdWk9O1QDGOG0Bq3T/nY0mgyZ9xuslZYMzWfc4dIGc=' />
        </div>
        <div class='row align-items-center mb-3'>
          <div class='col col-12 col-sm-2 mb-3 mb-sm-0'>
            <mat-label>Email</mat-label>
          </div>
          <div class='col col-12 col-sm-10'>
            <app-text-field
              formControlName='username'
              placeholder='Email address' type='email'></app-text-field>
          </div>
        </div>
        <div
          *ngIf='username.invalid && (username.dirty || username.touched)'
          class='alert alert-danger'>
          <div *ngIf='username.errors.required'>Email address is required.</div>
          <div *ngIf='username.errors.minlength'>
            Email address must be at least 4 characters long.
          </div>
          <div *ngIf='username.errors.email'>
            Please, enter valid email address
          </div>
        </div>
        <div class='row align-items-center mb-5'>
          <div class='col col-12 col-sm-2 mb-3 mb-sm-0'>
            <mat-label>Password</mat-label>
          </div>
          <div class='col col-12 col-sm-10'>
            <app-text-field
              [allowViewPassword]='true'
              formControlName='password'
              placeholder='Password'
              type='password'></app-text-field>
          </div>
        </div>
        <div
          *ngIf='password.invalid && (password.dirty || password.touched)'
          class='alert alert-danger'>
          <div *ngIf='password.errors.required'>Password is required.</div>
          <div *ngIf='password.errors.minlength'>
            Password must be at least 6 characters long.
          </div>
        </div>
        <div>
          <app-button
            [Click]='onSubmit'
            [disabled]="loginForm.invalid || loginInProgress"
            [color]="'orange'"
            [size]="'big'"
            [text]="'Login'"
            class='Login_wrapper_body_button'></app-button>
        </div>
        <div
          class='Login_wrapper_body_footer mt-3 d-flex justify-content-center flex-column'>
          <p>
            Forgot password? Click
            <a [routerLink]="['/forgot_password']" class='forg'>here</a>
          </p>
          <p class='mt-2'>
            Don't have an account. <a [routerLink]="['/register']">Sign up.</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
